module.exports = __webpack_public_path__ + "img/tulipe_maureen.1c4fa4d9.jpg";